import React from 'react'

import {
  useGlobalContext,
  setGenericLayer,
  sideBarRightVisibilityChanged,
  accordionChange,
  setFeatures
} from '../../state'

import { IconMap } from '../../utils/icons'
import { t } from '../../utils/languages'

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  IconButton
} from '@material-ui/core'

import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import { useStyles } from './styles'

export const Option = ({
  id,
  name,
  icon,
  type,
  color,
  submenu,
  arrowIcon,
  style
}) => {
  const classes = useStyles()
  const {
    state: { genericLayer, openAccordions },
    dispatch
  } = useGlobalContext()

  const handleOnClick = () => {
    if (genericLayer?.id === id) {
      dispatch(setGenericLayer({ id: null }))
      dispatch(
        sideBarRightVisibilityChanged({
          isOpen: false
        })
      )
    } else {
      dispatch(setGenericLayer({ id, name, color, icon, style }))
      dispatch(setFeatures({ features: [] }))
      dispatch(
        sideBarRightVisibilityChanged({
          isOpen: true,
          selectedType: 'dataTable'
        })
      )
    }
  }

  return (
    <>
      {!submenu || submenu.length === 0 ? (
        <Box className={classes.containerOption}>
          <Box className={classes.containerTitle}>
            <Box className={classes.boxIconOption}>
              {icon && (
                <FiberManualRecordIcon
                  className={classes.optionIcon}
                  style={{ color: color }}
                />
              )}
            </Box>
            <Typography className={classes.optionName} variant="h6">
              {t(name)}
            </Typography>
          </Box>
          <IconButton onClick={handleOnClick}>
            {genericLayer?.id === id
              ? IconMap.get('RadioButtonCheckedSharp')
              : IconMap.get('RadioButtonUnchecked')}
          </IconButton>
          {arrowIcon && IconMap.get(arrowIcon)}
        </Box>
      ) : (
        <Accordion className={type} expanded={openAccordions[type] === id}>
          <AccordionSummary
            expandIcon={arrowIcon && IconMap.get(arrowIcon)}
            className={type}
            onClick={() => dispatch(accordionChange({ id, type }))}
          >
            <Box className={classes.containerTitle}>
              <Box className={classes.boxIconOption}>
                {icon && (
                  <FiberManualRecordIcon
                    className={classes.optionIcon}
                    style={{ color: color }}
                  />
                )}
              </Box>
              <Typography className={classes.optionName} variant="h6">
                {t(name)}
              </Typography>
            </Box>
            <IconButton onClick={() => handleOnClick({ id })}>
              {genericLayer?.id === id
                ? IconMap.get('RadioButtonCheckedSharp')
                : IconMap.get('RadioButtonUnchecked')}
            </IconButton>
          </AccordionSummary>
          <AccordionDetails className="lastChildren">
            {submenu.map(
              ({ name, icon, query, queryRedmine, id: _id, color }, idx) => {
                return (
                  <Option
                    key={idx}
                    id={_id}
                    name={name}
                    color={color}
                    icon={icon}
                    query={query}
                    queryRedmine={queryRedmine}
                    style={style}
                  />
                )
              }
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </>
  )
}
